import { useNavigate } from 'react-router-dom';

import { RouterPaths } from 'src/components/Router/Router.constants';
import { useWhatsappApiContext } from 'src/pages/WhatsappApi/WhatsappApi.context';
import {
  eTemplateCategory,
  eWhatsappApiWindow,
} from 'src/pages/WhatsappApi/WhatsappApi.enum';
import { useModalsContext } from 'src/providers/ModalsProvider/Modals.context';

/**
 * Opens the WhatsApp API template editor with UTILITY preselected
 * ("Crear plantilla de seguimiento", INT-1500 D5): from the template picker's
 * empty Seguimiento filter and from a 131049 notice when the workspace has no
 * approved UTILITY template.
 */
export default function useOpenUtilityTemplateEditor(): () => void {
  const navigate = useNavigate();
  const { setWhatsappApiWindow, setPendingTemplateCategory } =
    useWhatsappApiContext();
  const { setChatModalIsOpen } = useModalsContext();

  return () => {
    setPendingTemplateCategory(eTemplateCategory.UTILITY);
    setWhatsappApiWindow(eWhatsappApiWindow.CREATE_TEMPLATE);
    setChatModalIsOpen(false);
    navigate(RouterPaths.wapi);
  };
}
